export const tableCompanyData =   [
    {
        name: 'Ethel Price',
        gender: 'female',
        company: 'Johnson, Johnson and Partners, LLC CMP DDC',
        age: 22
    },
    {
        name: 'Claudine Neal',
        gender: 'female',
        company: 'Sealoud',
        age: 55
    },
    {
        name: 'Beryl Rice',
        gender: 'female',
        company: 'Velity',
        age: 67
    },
    {
        name: 'Wilder Gonzales',
        gender: 'male',
        company: 'Geekko'
    },
    {
        name: 'Georgina Schultz',
        gender: 'female',
        company: 'Suretech'
    },
    {
        name: 'Carroll Buchanan',
        gender: 'male',
        company: 'Ecosys'
    },
    {
        name: 'Valarie Atkinson',
        gender: 'female',
        company: 'Hopeli'
    },
    {
        name: 'Schroeder Mathews',
        gender: 'male',
        company: 'Polarium'
    },
    {
        name: 'Lynda Mendoza',
        gender: 'female',
        company: 'Dogspa'
    },
    {
        name: 'Sarah Massey',
        gender: 'female',
        company: 'Bisba'
    },
    {
        name: 'Robles Boyle',
        gender: 'male',
        company: 'Comtract'
    },
    {
        name: 'Evans Hickman',
        gender: 'male',
        company: 'Parleynet'
    },
    {
        name: 'Dawson Barber',
        gender: 'male',
        company: 'Dymi'
    },
    {
        name: 'Bruce Strong',
        gender: 'male',
        company: 'Xyqag'
    },
    {
        name: 'Nellie Whitfield',
        gender: 'female',
        company: 'Exospace'
    },
    {
        name: 'Jackson Macias',
        gender: 'male',
        company: 'Aquamate'
    },
    {
        name: 'Pena Pena',
        gender: 'male',
        company: 'Quarx'
    },
    {
        name: 'Lelia Gates',
        gender: 'female',
        company: 'Proxsoft'
    },
    {
        name: 'Letitia Vasquez',
        gender: 'female',
        company: 'Slumberia'
    },
    {
        name: 'Trevino Moreno',
        gender: 'male',
        company: 'Conjurica'
    },
    {
        name: 'Barr Page',
        gender: 'male',
        company: 'Apex'
    },
    {
        name: 'Kirkland Merrill',
        gender: 'male',
        company: 'Utara'
    },
    {
        name: 'Blanche Conley',
        gender: 'female',
        company: 'Imkan'
    },
    {
        name: 'Atkins Dunlap',
        gender: 'male',
        company: 'Comveyor'
    },
    {
        name: 'Everett Foreman',
        gender: 'male',
        company: 'Maineland'
    },
    {
        name: 'Gould Randolph',
        gender: 'male',
        company: 'Intergeek'
    },
    {
        name: 'Kelli Leon',
        gender: 'female',
        company: 'Verbus'
    },
    {
        name: 'Freda Mason',
        gender: 'female',
        company: 'Accidency'
    },
    {
        name: 'Tucker Maxwell',
        gender: 'male',
        company: 'Lumbrex'
    },
    {
        name: 'Yvonne Parsons',
        gender: 'female',
        company: 'Zolar'
    },
    {
        name: 'Woods Key',
        gender: 'male',
        company: 'Bedder'
    },
    {
        name: 'Stephens Reilly',
        gender: 'male',
        company: 'Acusage'
    },
    {
        name: 'Mcfarland Sparks',
        gender: 'male',
        company: 'Comvey'
    },
    {
        name: 'Jocelyn Sawyer',
        gender: 'female',
        company: 'Fortean'
    },
    {
        name: 'Renee Barr',
        gender: 'female',
        company: 'Kiggle'
    },
    {
        name: 'Gaines Beck',
        gender: 'male',
        company: 'Sequitur'
    },
    {
        name: 'Luisa Farrell',
        gender: 'female',
        company: 'Cinesanct'
    },
    {
        name: 'Robyn Strickland',
        gender: 'female',
        company: 'Obones'
    },
    {
        name: 'Roseann Jarvis',
        gender: 'female',
        company: 'Aquazure'
    },
    {
        name: 'Johnston Park',
        gender: 'male',
        company: 'Netur'
    },
    {
        name: 'Wong Craft',
        gender: 'male',
        company: 'Opticall'
    },
    {
        name: 'Merritt Cole',
        gender: 'male',
        company: 'Techtrix'
    },
    {
        name: 'Dale Byrd',
        gender: 'female',
        company: 'Kneedles'
    },
    {
        name: 'Sara Delgado',
        gender: 'female',
        company: 'Netagy'
    },
    {
        name: 'Alisha Myers',
        gender: 'female',
        company: 'Intradisk'
    },
    {
        name: 'Felecia Smith',
        gender: 'female',
        company: 'Futurity'
    },
    {
        name: 'Neal Harvey',
        gender: 'male',
        company: 'Pyramax'
    },
    {
        name: 'Nola Miles',
        gender: 'female',
        company: 'Sonique'
    },
    {
        name: 'Herring Pierce',
        gender: 'male',
        company: 'Geeketron'
    },
    {
        name: 'Shelley Rodriquez',
        gender: 'female',
        company: 'Bostonic'
    },
    {
        name: 'Cora Chase',
        gender: 'female',
        company: 'Isonus'
    },
    {
        name: 'Mckay Santos',
        gender: 'male',
        company: 'Amtas'
    },
    {
        name: 'Hilda Crane',
        gender: 'female',
        company: 'Jumpstack'
    },
    {
        name: 'Jeanne Lindsay',
        gender: 'female',
        company: 'Genesynk'
    },
    {
        name: 'Frye Sharpe',
        gender: 'male',
        company: 'Eplode'
    },
    {
        name: 'Velma Fry',
        gender: 'female',
        company: 'Ronelon'
    },
    {
        name: 'Reyna Espinoza',
        gender: 'female',
        company: 'Prismatic'
    },
    {
        name: 'Spencer Sloan',
        gender: 'male',
        company: 'Comverges'
    },
    {
        name: 'Graham Marsh',
        gender: 'male',
        company: 'Medifax'
    },
    {
        name: 'Hale Boone',
        gender: 'male',
        company: 'Digial'
    },
    {
        name: 'Wiley Hubbard',
        gender: 'male',
        company: 'Zensus'
    },
    {
        name: 'Blackburn Drake',
        gender: 'male',
        company: 'Frenex'
    },
    {
        name: 'Franco Hunter',
        gender: 'male',
        company: 'Rockabye'
    },
    {
        name: 'Barnett Case',
        gender: 'male',
        company: 'Norali'
    },
    {
        name: 'Alexander Foley',
        gender: 'male',
        company: 'Geekosis'
    },
    {
        name: 'Lynette Stein',
        gender: 'female',
        company: 'Macronaut'
    },
    {
        name: 'Anthony Joyner',
        gender: 'male',
        company: 'Senmei'
    },
    {
        name: 'Garrett Brennan',
        gender: 'male',
        company: 'Bluegrain'
    },
    {
        name: 'Betsy Horton',
        gender: 'female',
        company: 'Zilla'
    },
    {
        name: 'Patton Small',
        gender: 'male',
        company: 'Genmex'
    },
    {
        name: 'Lakisha Huber',
        gender: 'female',
        company: 'Insource'
    },
    {
        name: 'Lindsay Avery',
        gender: 'female',
        company: 'Unq'
    },
    {
        name: 'Ayers Hood',
        gender: 'male',
        company: 'Accuprint'
    },
    {
        name: 'Torres Durham',
        gender: 'male',
        company: 'Uplinx'
    },
    {
        name: 'Vincent Hernandez',
        gender: 'male',
        company: 'Talendula'
    },
    {
        name: 'Baird Ryan',
        gender: 'male',
        company: 'Aquasseur'
    },
    {
        name: 'Georgia Mercer',
        gender: 'female',
        company: 'Skyplex'
    },
    {
        name: 'Francesca Elliott',
        gender: 'female',
        company: 'Nspire'
    },
    {
        name: 'Lyons Peters',
        gender: 'male',
        company: 'Quinex'
    },
    {
        name: 'Kristi Brewer',
        gender: 'female',
        company: 'Oronoko'
    },
    {
        name: 'Tonya Bray',
        gender: 'female',
        company: 'Insuron'
    },
    {
        name: 'Valenzuela Huff',
        gender: 'male',
        company: 'Applideck'
    },
    {
        name: 'Tiffany Anderson',
        gender: 'female',
        company: 'Zanymax'
    },
    {
        name: 'Jerri King',
        gender: 'female',
        company: 'Eventex'
    },
    {
        name: 'Rocha Meadows',
        gender: 'male',
        company: 'Goko'
    },
    {
        name: 'Marcy Green',
        gender: 'female',
        company: 'Pharmex'
    },
    {
        name: 'Kirk Cross',
        gender: 'male',
        company: 'Portico'
    },
    {
        name: 'Hattie Mullen',
        gender: 'female',
        company: 'Zilencio'
    },
    {
        name: 'Deann Bridges',
        gender: 'female',
        company: 'Equitox'
    },
    {
        name: 'Chaney Roach',
        gender: 'male',
        company: 'Qualitern'
    },
    {
        name: 'Consuelo Dickson',
        gender: 'female',
        company: 'Poshome'
    },
    {
        name: 'Billie Rowe',
        gender: 'female',
        company: 'Cemention'
    },
    {
        name: 'Bean Donovan',
        gender: 'male',
        company: 'Mantro'
    },
    {
        name: 'Lancaster Patel',
        gender: 'male',
        company: 'Krog'
    },
    {
        name: 'Rosa Dyer',
        gender: 'female',
        company: 'Netility'
    },
    {
        name: 'Christine Compton',
        gender: 'female',
        company: 'Bleeko'
    },
    {
        name: 'Milagros Finch',
        gender: 'female',
        company: 'Handshake'
    },
    {
        name: 'Ericka Alvarado',
        gender: 'female',
        company: 'Lyrichord'
    },
    {
        name: 'Sylvia Sosa',
        gender: 'female',
        company: 'Circum'
    },
    {
        name: 'Humphrey Curtis',
        gender: 'male',
        company: 'Corepan'
    }
]

export const tableTreeData = [
    {
        name: 'Ethel Price',
        gender: 'female',
        company: 'Johnson, Johnson and Partners, LLC CMP DDC',
        age: 22,
        treeStatus: 'collapsed'
    },
    {
        name: 'Claudine Neal',
        gender: 'female',
        company: 'Sealoud',
        age: 55,
        treeStatus: 'disabled'
    },
    {
        name: 'Beryl Rice',
        gender: 'female',
        company: 'Velity',
        age: 67,
        treeStatus: 'disabled'
    },
    {
        name: 'Wilder Gonzales',
        gender: 'male',
        company: 'Geekko',
        treeStatus: 'disabled'
    },
    {
        name: 'Georgina Schultz',
        gender: 'female',
        company: 'Suretech',
        treeStatus: 'collapsed'
    },
    {
        name: 'Carroll Buchanan',
        gender: 'male',
        company: 'Ecosys',
        treeStatus: 'disabled'
    },
    {
        name: 'Valarie Atkinson',
        gender: 'female',
        company: 'Hopeli',
        treeStatus: 'disabled'
    },
    {
        name: 'Schroeder Mathews',
        gender: 'male',
        company: 'Polarium',
        manager: 'Ethel Price',
        treeStatus: 'disabled'
    },
    {
        name: 'Lynda Mendoza',
        gender: 'female',
        company: 'Dogspa',
        manager: 'Georgina Schultz',
        treeStatus: 'disabled'
    }
]

export const tableRowData =   [
    {
        id: 0,
        name: 'Ramsey Cummings',
        gender: 'male',
        age: 52,
        address: {
          state: 'South Carolina',
          city: 'Glendale'
        }
      },
      {
        id: 1,
        name: 'Stefanie Huff',
        gender: 'female',
        age: 70,
        address: {
          state: 'Arizona',
          city: 'Beaverdale'
        }
      },
      {
        id: 2,
        name: 'Mabel David',
        gender: 'female',
        age: 52,
        address: {
          state: 'New Mexico',
          city: 'Grazierville'
        }
      },
      {
        id: 3,
        name: 'Frank Bradford',
        gender: 'male',
        age: 61,
        address: {
          state: 'Wisconsin',
          city: 'Saranap'
        }
      },
      {
        id: 4,
        name: 'Forbes Levine',
        gender: 'male',
        age: 34,
        address: {
          state: 'Vermont',
          city: 'Norris'
        }
      },
      {
        id: 5,
        name: 'Santiago Mcclain',
        gender: 'male',
        age: 38,
        address: {
          state: 'Montana',
          city: 'Bordelonville'
        }
      },
      {
        id: 6,
        name: 'Merritt Booker',
        gender: 'male',
        age: 33,
        address: {
          state: 'New Jersey',
          city: 'Aguila'
        }
      },
      {
        id: 7,
        name: 'Oconnor Wade',
        gender: 'male',
        age: 18,
        address: {
          state: 'Virginia',
          city: 'Kenmar'
        }
      },
      {
        id: 8,
        name: 'Leigh Beasley',
        gender: 'female',
        age: 53,
        address: {
          state: 'Texas',
          city: 'Alfarata'
        }
      },
      {
        id: 9,
        name: 'Johns Wood',
        gender: 'male',
        age: 52,
        address: {
          state: 'Maine',
          city: 'Witmer'
        }
      },
      {
        id: 10,
        name: 'Thompson Hays',
        gender: 'male',
        age: 38,
        address: {
          state: 'Nevada',
          city: 'Kipp'
        }
      },
      {
        id: 11,
        name: 'Hallie Mack',
        gender: 'female',
        age: 19,
        address: {
          state: 'Minnesota',
          city: 'Darrtown'
        }
      },
      {
        id: 12,
        name: 'Houston Santos',
        gender: 'male',
        age: 24,
        address: {
          state: 'Georgia',
          city: 'Crucible'
        }
      },
      {
        id: 13,
        name: 'Brandy Savage',
        gender: 'female',
        age: 65,
        address: {
          state: 'Idaho',
          city: 'Nord'
        }
      },
      {
        id: 14,
        name: 'Finch Barnett',
        gender: 'male',
        age: 22,
        address: {
          state: 'Ohio',
          city: 'Osmond'
        }
      },
      {
        id: 15,
        name: 'Nicole Crosby',
        gender: 'female',
        age: 77,
        address: {
          state: 'Kentucky',
          city: 'Fairfield'
        }
      },
      {
        id: 16,
        name: 'Carrie Mcconnell',
        gender: 'female',
        age: 26,
        address: {
          state: 'South Dakota',
          city: 'Waikele'
        }
      },
      {
        id: 17,
        name: 'Ann James',
        gender: 'female',
        age: 37,
        address: {
          state: 'North Dakota',
          city: 'Siglerville'
        }
      },
      {
        id: 18,
        name: 'Becky Sanford',
        gender: 'female',
        age: 48,
        address: {
          state: 'Massachusetts',
          city: 'Celeryville'
        }
      },
      {
        id: 19,
        name: 'Kathryn Rios',
        gender: 'female',
        age: 39,
        address: {
          state: 'Delaware',
          city: 'Kylertown'
        }
      },
      {
        id: 20,
        name: 'Dotson Vaughn',
        gender: 'male',
        age: 68,
        address: {
          state: 'Arkansas',
          city: 'Monument'
        }
      },
      {
        id: 21,
        name: 'Wright Kline',
        gender: 'male',
        age: 41,
        address: {
          state: 'Missouri',
          city: 'Bynum'
        }
      },
      {
        id: 22,
        name: 'Lula Morgan',
        gender: 'female',
        age: 52,
        address: {
          state: 'Oregon',
          city: 'Mapletown'
        }
      },
      {
        id: 23,
        name: 'Kay Mendez',
        gender: 'female',
        age: 50,
        address: {
          state: 'Michigan',
          city: 'Twilight'
        }
      },
      {
        id: 24,
        name: 'Mona Maddox',
        gender: 'female',
        age: 35,
        address: {
          state: 'Wyoming',
          city: 'Wilmington'
        }
      },
      {
        id: 25,
        name: 'Fulton Velez',
        gender: 'male',
        age: 66,
        address: {
          state: 'Colorado',
          city: 'Loretto'
        }
      },
      {
        id: 26,
        name: 'Ericka Craft',
        gender: 'female',
        age: 80,
        address: {
          state: 'Nebraska',
          city: 'Beaulieu'
        }
      },
      {
        id: 27,
        name: 'Richmond Rodriguez',
        gender: 'male',
        age: 62,
        address: {
          state: 'Rhode Island',
          city: 'Vallonia'
        }
      },
      {
        id: 28,
        name: 'Olsen Farmer',
        gender: 'male',
        age: 45,
        address: {
          state: 'Connecticut',
          city: 'Romeville'
        }
      },
      {
        id: 29,
        name: 'Sophie Austin',
        gender: 'female',
        age: 59,
        address: {
          state: 'New Hampshire',
          city: 'Gorst'
        }
      },
      {
        id: 30,
        name: 'Alta Olsen',
        gender: 'female',
        age: 58,
        address: {
          state: 'Florida',
          city: 'Drytown'
        }
      },
      {
        id: 31,
        name: 'Katherine Chavez',
        gender: 'female',
        age: 20,
        address: {
          state: 'Mississippi',
          city: 'Trucksville'
        }
      },
      {
        id: 32,
        name: 'Yvette Myers',
        gender: 'female',
        age: 69,
        address: {
          state: 'Washington',
          city: 'Bangor'
        }
      },
      {
        id: 33,
        name: 'Nguyen Dean',
        gender: 'male',
        age: 58,
        address: {
          state: 'Alaska',
          city: 'Caroline'
        }
      },
      {
        id: 34,
        name: 'Lauri Irwin',
        gender: 'female',
        age: 23,
        address: {
          state: 'Hawaii',
          city: 'Takilma'
        }
      },
      {
        id: 35,
        name: 'David Mclean',
        gender: 'male',
        age: 49,
        address: {
          state: 'Louisiana',
          city: 'Harviell'
        }
      },
      {
        id: 36,
        name: 'Tisha Cotton',
        gender: 'female',
        age: 78,
        address: {
          state: 'Illinois',
          city: 'Camas'
        }
      },
      {
        id: 37,
        name: 'Eliza Conrad',
        gender: 'female',
        age: 82,
        address: {
          state: 'Utah',
          city: 'Gwynn'
        }
      },
      {
        id: 38,
        name: 'Bolton Cooley',
        gender: 'male',
        age: 44,
        address: {
          state: 'Oklahoma',
          city: 'Glidden'
        }
      },
      {
        id: 39,
        name: 'Crosby Osborn',
        gender: 'male',
        age: 44,
        address: {
          state: 'Alabama',
          city: 'Buxton'
        }
      },
      {
        id: 40,
        name: 'Reese Tran',
        gender: 'male',
        age: 53,
        address: {
          state: 'Maryland',
          city: 'Kempton'
        }
      },
      {
        id: 41,
        name: 'Evangeline Larson',
        gender: 'female',
        age: 49,
        address: {
          state: 'Pennsylvania',
          city: 'Mayfair'
        }
      },
      {
        id: 42,
        name: 'Jimenez Frazier',
        gender: 'male',
        age: 23,
        address: {
          state: 'California',
          city: 'Ronco'
        }
      },
      {
        id: 43,
        name: 'Conner Tate',
        gender: 'male',
        age: 39,
        address: {
          state: 'West Virginia',
          city: 'Eastvale'
        }
      },
      {
        id: 44,
        name: 'Avery Rosales',
        gender: 'male',
        age: 71,
        address: {
          state: 'Tennessee',
          city: 'Cascades'
        }
      },
      {
        id: 45,
        name: 'Burris Marquez',
        gender: 'male',
        age: 32,
        address: {
          state: 'North Carolina',
          city: 'Chamizal'
        }
      },
      {
        id: 46,
        name: 'Hoover Cardenas',
        gender: 'male',
        age: 65,
        address: {
          state: 'Kansas',
          city: 'Joes'
        }
      },
      {
        id: 47,
        name: 'Moran Gomez',
        gender: 'male',
        age: 40,
        address: {
          state: 'New York',
          city: 'Knowlton'
        }
      },
      {
        id: 48,
        name: 'Boyd Juarez',
        gender: 'male',
        age: 33,
        address: {
          state: 'Iowa',
          city: 'Hemlock'
        }
      },
      {
        id: 49,
        name: 'John Mooney',
        gender: 'female',
        age: 73,
        address: {
          state: 'Rhode Island',
          city: 'Gardners'
        }
      },
      {
        id: 50,
        name: 'Avery Crawford',
        gender: 'male',
        age: 39,
        address: {
          state: 'Hawaii',
          city: 'Woodruff'
        }
      }
]